import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function BlogPost() {
    const { slug } = useParams();
    const [p, setP] = useState(null);

    useEffect(() => {
        setP(null);
        api.get(`/blog/${slug}`).then((r) => setP(r.data));
    }, [slug]);

    if (!p)
        return (
            <div
                className="max-w-[900px] mx-auto px-6 md:px-12 py-40 text-center"
                style={{ color: "var(--vl-muted)" }}
            >
                Loading…
            </div>
        );

    return (
        <article
            className="max-w-[780px] mx-auto px-6 md:px-12 pt-12 pb-32"
            data-testid="blog-post-page"
        >
            <Link
                to="/blog"
                className="overline"
                style={{ color: "var(--vl-muted)" }}
            >
                ← Back to Journal
            </Link>

            <div className="overline mt-10">
                {p.date} · {p.read_time}
            </div>
            <h1
                className="font-serif text-4xl sm:text-5xl tracking-tight mt-4"
                style={{ color: "var(--vl-text)" }}
                data-testid="blog-post-title"
            >
                {p.title}
            </h1>
            <p
                className="mt-4 text-sm"
                style={{ color: "var(--vl-muted)" }}
            >
                By {p.author}
            </p>

            <img
                src={p.cover}
                alt={p.title}
                className="w-full aspect-[21/9] object-cover mt-10"
                style={{ filter: "brightness(0.85)" }}
            />

            <div
                className="mt-12 font-serif text-lg sm:text-xl space-y-6"
                style={{ color: "var(--vl-text)", lineHeight: 1.8 }}
            >
                {p.content.split("\n\n").map((para, i) => (
                    <p key={`para-${i}`}>{para}</p>
                ))}
            </div>
        </article>
    );
}
